<app-dashboard-layout [notDashboard]="true">
    <section class="bg-white border rounded-md p-4">
      <header class="border-b flex text-lg mb-6 w-full pb-4 gap-8 md:text-xl">
        Parents/Guardians
      </header>
  
      <app-notification-alert [data]="notification"></app-notification-alert>
      <nav class="flex flex-col gap-4">
        <div class="grid gap-8 grid-cols-1 md:grid-cols-4">
          <div class="w-full"></div>
          <div class="w-full"></div>
          <app-button-primary type="button" class="w-full" 
          [outline]="true" [disabled]="loading" (click)="editGuardianList()">
            <div>EDIT GUARDIAN LIST</div>
            <div class="material-icons">edit</div>
          </app-button-primary>
          <app-button-primary type="button" class="w-full" 
          [disabled]="loading" (click)="addGuardian()">
            <div>ADD GUARDIAN</div>
            <div class="material-icons">add</div>
          </app-button-primary>
        </div>
      </nav>
      <div *ngIf="skeletonLoader" class="grid pb-4 gap-4 gap-8 grid-cols-1 md:grid-cols-4">
        <div *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]" class="border rounded-md bg-gray-300 h-20 animate-pulse"></div>
      </div>
      <table *ngIf="!skeletonLoader && GuadiansDTO.length > 0" class="w-full text-sm text-left text-gray-600 md:block">
        <thead class="text-xs text-gray-700 bg-primary/5">
            <tr>
                <th scope="col" class="py-3 px-6">
                    
                </th>
                <th scope="col" class="py-3 px-6">
                    Name
                </th>                                
                <th scope="col" class="py-3 px-6">        
                    Relationship With Child
                </th>
                <th scope="col" class="py-3 px-6">
                    Phone Number
                </th>
                <th scope="col" class="py-3 px-6">
                    Email
                </th>
                <th scope="col" class="py-3 px-6">
                    Home Address
                </th>
                <th scope="col" class="py-3 px-6">
                </th>
                <th scope="col" class="py-3 px-6">
                    
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let x of totalGuardians(); let i = index" class="bg-white border-b" >
                <th scope="row" class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap">
                  <div class="bg-cover bg-center bg-no-repeat border rounded-full mx-auto border-1 h-20 w-20" 
                  [style]="GuadiansDTO[i].ImageUrl? 'background-image: url(' + GuadiansDTO[i].ImageUrl +')'
                    : 'background-image: url(https://www.gravatar.com/avatar/?d=mp)'">
                  </div>
                </th>
                <td class="py-4 px-6">
                    {{GuadiansDTO[i].Name}}
                </td>
                <td class="py-4 px-6">
                    {{GuadiansDTO[i].RelationshipWithChild}}
                </td>
                <td class="py-4 px-6">
                    {{GuadiansDTO[i].PhoneNumber}}
                </td>
                <td class="py-4 px-6">
                    {{GuadiansDTO[i].Email}}
                </td>
                <td class="py-4 px-6">
                    {{GuadiansDTO[i].HomeAddress}}
                </td>
                <td (click)="editGuardian(i)" class="py-4 px-6 text-lightBlue cursor-pointer">
                    <div class="material-icons">edit</div>
                </td>
                <td (click)="toggleDeleteDialog(GuadiansDTO[i].GuardianID)" class="py-4 px-6 text-error cursor-pointer">
                    <div class="material-icons">delete</div>
                </td>
            </tr>
        </tbody>
    </table>
    <app-no-content *ngIf="!skeletonLoader && GuadiansDTO.length == 0"></app-no-content>


    </section>




    <app-delete-dialog [deleteDialog]="showDeleteDialog" (shouldDelete)="deleteGuardian($event)"></app-delete-dialog>
  </app-dashboard-layout>
  
  <section
  role="dialog"
  aria-modal="true"
  *ngIf="showFormDialog"
  aria-labelledby="modal-title"
  class="inset-0 z-10 fixed overflow-y-auto"
>
  <div class="flex flex-col h-full text-center p-4 items-center justify-center">
    <div
      aria-hidden="true"
      class="bg-gray-500 bg-opacity-75 inset-0 transition-opacity fixed"
    ></div>

    <div
      class="bg-white rounded-lg shadow-xl text-left w-full transform transition-all overflow-y-auto sm:max-w-screen-sm sm:my-8"
    >

      <section class="p-8">

        <app-notification-alert [data]="notification"></app-notification-alert>
        
      <form ngNativeValidate 
      *ngIf="!skeletonLoader" id="biodata-education" (ngSubmit)="saveGuardian()"
      class="max-w-screen-md grid gap-8 grid-cols-1">
      <div
        class="border-primary-lighter border-b-2 grid pb-8 gap-8 grid-cols-1">
        <app-guardian-form-fields [states]="states" [ChildLeavingWith]="ChildLeavingWith" [guardianToSave]="guardianToSave" ></app-guardian-form-fields>
  
      </div>

      <nav class="flex flex-col py-2 gap-4">
        <div class="grid py-2 gap-8 grid-cols-1 md:grid-cols-2">
          <app-button-primary type="button" class="w-full" [outline]="true" [disabled]="loading" 
          (click)="closeForm()">
            <div>CANCEL</div>
          </app-button-primary>

          <app-button-primary type="submit" [disabled]="loading" class="w-full">
            SAVE GUARDIAN
          </app-button-primary>
        </div>

        <app-notification-alert [data]="notification"></app-notification-alert>
      </nav>
    </form>
      </section>
    </div>
  </div>
</section>